// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-cards-ciriumCard-module__ciriumCardFlex--QZ3BQ {
    justify-content: space-around;
}

.src-js-components-cards-ciriumCard-module__textAlignCenter--sBjfo {
    text-align: center;
}

.src-js-components-cards-ciriumCard-module__spacing3--PI6wC {
    margin-bottom: 1.5rem;
}

.src-js-components-cards-ciriumCard-module__spacing2--MVdk4 {
    font-size: 16px !important;
    font-family: Montserrat, Arial, sans-serif !important;
    margin-bottom: 1rem;
    line-height: normal!important;
}`, "",{"version":3,"sources":["webpack://./src/js/components/cards/ciriumCard.module.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,qDAAqD;IACrD,mBAAmB;IACnB,6BAA6B;AACjC","sourcesContent":[".ciriumCardFlex {\n    justify-content: space-around;\n}\n\n.textAlignCenter {\n    text-align: center;\n}\n\n.spacing3 {\n    margin-bottom: 1.5rem;\n}\n\n.spacing2 {\n    font-size: 16px !important;\n    font-family: Montserrat, Arial, sans-serif !important;\n    margin-bottom: 1rem;\n    line-height: normal!important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ciriumCardFlex": `src-js-components-cards-ciriumCard-module__ciriumCardFlex--QZ3BQ`,
	"textAlignCenter": `src-js-components-cards-ciriumCard-module__textAlignCenter--sBjfo`,
	"spacing3": `src-js-components-cards-ciriumCard-module__spacing3--PI6wC`,
	"spacing2": `src-js-components-cards-ciriumCard-module__spacing2--MVdk4`
};
export default ___CSS_LOADER_EXPORT___;
